import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getAccessToken } from "../../../_services/localStorage.service";
import { userActions } from "../../../_actions/user.actions";
import "./userAvatar.scss";
function UserAvatar({ styleName, children, navbar }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);

  useEffect(() => {
    if (!user && getAccessToken()) {
      dispatch(userActions.getUserInfo());
    }
  }, []);

  return user ? (
    <div className="avatar-flex-new">
      <div>
        <span className={`user-avatar ${styleName}`}>
          {user.profileImage ? (
            <img alt="Profile" src={user.profileImage} />
          ) : (
            user && <span>{user.firstName.charAt(0)}</span>
          )}
          <span className="icon-wrapper">
            <i className="icon-camera"></i>
          </span>
        </span>
      </div>
      {navbar && (
        <div className="custom-div-position">
          <p className="para-p">{user.firstName}</p>
          {user?.role === 1 && <p className="admin-avator">Admin</p>}
          {user?.role === 2 && <p className="admin-avator">Student</p>}
          {user?.role === 3 && <p className="admin-avator">Enterprise</p>}
          {user?.role === 4 && <p className="admin-avator">Instructor</p>}
        </div>
      )}
    </div>
  ) : null;
}

UserAvatar.propTypes = {
  styleName: PropTypes.string,
};

UserAvatar.defaultProps = {
  styleName: "",
};

export default UserAvatar;
